import { legacySizes } from '~/constants/common/resizeBreakpoints';
import useDataDogRUM from '~/hooks/common/telemetry/useDataDogRUM';
import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';
import useResizeListener from '~/hooks/common/ui/useResizeListener';
import setLocalBrowserCookieId from '~/pages-utils/setLocalBrowserCookieId';

export default function VendingMachineData() {
  useDataDogRUM();
  setLocalBrowserCookieId();
  useTrackClickEvents();
  useResizeListener(legacySizes);

  return null;
}
